<template>
    <ChartPanel title="Top productos" type="horizontalBar" :labels="chart.labels" :data="chart.data"
        :options="options.horizontal" :loading="loading" :error="error">
        <template v-slot:actions>
            <FilterBadges :badges="filterBadges" class="mr-2"></FilterBadges>
            <CurrencyToggle v-model="selected" :codes="codes"></CurrencyToggle>
        </template>
    </ChartPanel>
</template>
<script>
import DashboardDataService from '@/service/dashboard/DashboardDataService';
import { dashboardFilterMixin, dashboardRangeMixin, dashboardWidgetMixin } from '@/mixins/dashboardWidgetMixin';
import ChartPanel from './ChartPanel.vue';
import CurrencyToggle from './CurrencyToggle.vue';
import FilterBadges from './FilterBadges.vue';
import { chartFor, currencyCodes, moneyChartOptions, pickCurrency } from './dashboardData';

const TOP = 5;

/** Los 5 productos que más dinero dejaron en el periodo (`api/v1/dashboard/productos/top`), por moneda. */
export default {
    name: 'GraficaProductos',
    components: { ChartPanel, CurrencyToggle, FilterBadges },
    mixins: [dashboardWidgetMixin, dashboardRangeMixin, dashboardFilterMixin],
    // Con un producto elegido el tablero oculta este widget (sería una sola barra); el motivo queda aquí por si se monta suelto.
    filterScope: {
        sucursal: true,
        producto: false,
        reasons: { producto: 'Es el ranking entre productos: con un producto elegido sería una sola barra.' }
    },
    data() {
        return { rows: [], selected: '' };
    },
    computed: {
        codes() {
            return currencyCodes(this.rows);
        },
        currency() {
            return pickCurrency(this.codes, this.selected);
        },
        chart() {
            return chartFor(this.rows, this.currency, { labelKey: 'producto' });
        },
        options() {
            return moneyChartOptions(this.currency);
        }
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            return this.loadWidget(() => DashboardDataService.topProductos(this.startNatural, this.endNatural, TOP, this.filters), (data) => {
                this.rows = Array.isArray(data) ? data : [];
            });
        }
    }
};
</script>
